import { render, staticRenderFns } from "./PromptBar.vue?vue&type=template&id=12bd5760"
import script from "./PromptBar.vue?vue&type=script&lang=js"
export * from "./PromptBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports